(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /*
     * For CF7. Handles additional logic on the multiple choice form.
     * Based on interest selection, auto-select a hidden value.
     * Currently only for the prototype interest question.
     */

    (function () {
        const choiceForms = document.querySelectorAll('.multichoice-form');
        if (!choiceForms.length) {
            return;
        }

        choiceForms.forEach((choiceForm) => {
            const selectList = choiceForm.querySelector('.multichoice');
            if (!selectList) {
                return;
            }

            // For now, we just need to look for the prototype option
            // so that we can auto-select that value in the volumes dropdown...
            const prototype = 'prototype';
            const volume = choiceForm.querySelector(
                'select.application_volume option[value=Prototype]'
            );

            if (!volume) {
                return;
            }

            selectList.addEventListener('change', function handleChange(event) {
                const selection = this.options[this.selectedIndex].text;

                if (selection.includes(prototype)) {
                    volume.setAttribute('selected', 'selected');
                } else {
                    volume.removeAttribute('selected');
                }
            });
        });
    })();

}));
